import React from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';
import { Box, Divider, Notification, StackView, Typography } from '@telus-uds/components-web';

import Table from './components/table';
import SectionHeading from '../sectionHeading';

const TechnicalServices = ({
  hardware,
  productSelected,
  viewType,
  technicalServicesList,
  technicalServices,
  setTechnicalServices,
  total,
  setTotal,
  contentfulError,
  formErrors
}) => {
  const errorMessage = _.get(formErrors, 'iotTechnicalServices.text', '');

  return (
    <>
      {contentfulError && (
        <Notification variant={{ validation: 'error' }}>
          Error fetching TechnicalServices data from contentful
        </Notification>
      )}
      {!contentfulError && technicalServicesList.length > 0 && (
        <>
          <StackView space={3}>
            <SectionHeading><Typography heading="h4" variant={{ size: 'h4' }} block>Optional Technical Services</Typography></SectionHeading>
            <Table
              hardware={hardware}
              productSelected={productSelected}
              viewType={viewType}
              technicalServices={technicalServices}
              setTechnicalServices={setTechnicalServices}
              list={technicalServicesList}
              total={total}
              setTotal={setTotal}
            />
          </StackView>
          <Divider space={3} variant={{ inverse: true }} />
        </>
      )}
      {errorMessage && (
        <Notification variant={{ validation: 'error' }}>
          {errorMessage}
        </Notification>
      )}
    </>
  );
};

TechnicalServices.propTypes = {
  hardware: PropTypes.shape({}).isRequired,
  productSelected: PropTypes.string.isRequired,
  viewType: PropTypes.string.isRequired,
  technicalServicesList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  technicalServices: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  setTechnicalServices: PropTypes.func.isRequired,
  total: PropTypes.shape({
    ratePlan: PropTypes.number,
    subscriberList: PropTypes.number,
    additionalServices: PropTypes.number,
    addons: PropTypes.number,
    hardware: PropTypes.number,
    accessories: PropTypes.number,
    deliveryCharges: PropTypes.number
  }).isRequired,
  setTotal: PropTypes.func.isRequired,
  contentfulError: PropTypes.shape({}).isRequired,
  formErrors: PropTypes.shape({}).isRequired
};

export default TechnicalServices;
